import {
  AlertOctagon,
  AlertTriangle,
} from "@hl/base-components/lib/assets/icons/HDS";
import { Alert, Anchor } from "@mantine/core";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";

export const warningCopy = {
  red: "This project is under investigation for violations of our terms of service and/or community standards. Please proceed with caution.",
  yellow:
    "This project has been flagged by community members and is currently under review. Please proceed at your own risk.",
};

export const CustomWarning = ({ text }: { text: string }) => (
  <ReactMarkdown
    remarkPlugins={[gfm]}
    components={{
      a: (props) => (
        <Anchor
          target="_blank"
          rel="noopener noreferrer"
          {...props}
          sx={(theme) => ({
            fontSize: theme.fontSizes.sm,
            textDecoration: "underline",
            wordBreak: "break-word",
          })}
        />
      ),
    }}
  >
    {text}
  </ReactMarkdown>
);

type MintWarning = {
  level: "red" | "yellow";
  message: string | null;
  mintingPaused?: boolean;
};

export const SpamWarning = ({ mintWarning }: { mintWarning: MintWarning }) => {
  if (!mintWarning) return null;
  return (
    <Alert
      icon={mintWarning?.level === "red" ? <AlertOctagon /> : <AlertTriangle />}
      color={mintWarning.level}
    >
      {mintWarning?.message ? (
        <CustomWarning text={mintWarning.message} />
      ) : (
        warningCopy[mintWarning.level]
      )}
    </Alert>
  );
};
